/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsClockArrowUp: {
  name: 'clock-arrow-up';
  data: string;
} = {
  name: 'clock-arrow-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.707 5.293a1 1 0 0 0-1.414 0l-2 2a1 1 0 0 0 1.414 1.414L18 8.414V18a1 1 0 1 0 2 0V8.414l.293.293a1 1 0 1 0 1.414-1.414l-2-2ZM9 7a5 5 0 1 0 0 10A5 5 0 0 0 9 7Zm-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1a2 2 0 0 1-2-2v-1a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
